import type { ReactNode } from "react";
import type { Delta } from "../lib/types";
import { DeltaBadge } from "./DeltaBadge";

/**
 * A single headline metric. Per the dataviz form heuristic, a single number's
 * job is a stat tile, not a chart.
 */
export function StatTile({
  label,
  value,
  delta,
  deltaGood = "up",
  sub,
}: {
  label: string;
  value: ReactNode;
  delta?: Delta;
  deltaGood?: "up" | "down" | "neutral";
  sub?: ReactNode;
}) {
  return (
    <div className="card p-4">
      <div className="text-xs font-medium uppercase tracking-wide text-muted">{label}</div>
      <div className="mt-2 flex items-end gap-2">
        <div className="text-2xl font-semibold text-ink tnum">{value}</div>
        {delta && <DeltaBadge delta={delta} good={deltaGood} className="mb-1" />}
      </div>
      {sub && <div className="mt-1 text-xs text-muted">{sub}</div>}
    </div>
  );
}
